import { render, staticRenderFns } from "./LotDetailsPercents.vue?vue&type=template&id=74596a7c"
import script from "./LotDetailsPercents.vue?vue&type=script&lang=js"
export * from "./LotDetailsPercents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports